import { toInteger } from "lodash";
import { useEffect } from "react";

import { sdk } from "@gc/ipecs-web-sdk";
import { Icon, Menu, Popup } from "semantic-ui-react";
import ContactDisplayName from "./ContactDisplayName";
import { SideScrollerSidebarItem } from "./SideScrollerLayout";
import { LoadingState } from "./ui";

import { useAuth } from "../contexts/AuthContext";
import { useCallLogs } from "../contexts/CallLogsContext";
import { useCalls } from "../contexts/CallsContext";

function CallLogs() {
  const { hasActiveCall, handleMakeCall } = useCalls();
  const { callLogs, setCallLogs, setMissedCallCount } = useCallLogs();
  const { apiUser } = useAuth();
  const { callLog } = sdk;

  useEffect(() => {
    callLog.getCallLogs().then((res) => setCallLogs(res.callLogs));

    const intervalId = setInterval(() => {
      callLog.getCallLogs().then((res) => setCallLogs(res.callLogs));
    }, 60000);

    return () => clearInterval(intervalId);
  }, [callLog, setCallLogs]);

  useEffect(() => {
    setMissedCallCount(0);
    callLog.confirmCallLogs();
  }, [callLog, setMissedCallCount]);

  if (callLogs === null) {
    return <LoadingState style={{ minHeight: "200px" }} />;
  }

  const getCallLogName = (x) => {
    return /^[0-9]*$/.test(x.counterpart)
      ? {
          ...x,
          counterpartName: (
            <ContactDisplayName
              name={x.counterpartName}
              number={x.counterpartNumber}
              enableLookup={apiUser?.limit_api_lookups ? false : true}
            />
          ),
        }
      : x;
  };

  const secondsToMMSS = (seconds) => {
    const roundedSeconds = Math.round(seconds);
    return `${Math.floor(roundedSeconds / 60)}:${(roundedSeconds % 60)
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <>
      {callLogs.map(getCallLogName).map((x) => (
        <SideScrollerSidebarItem key={x.id}>
          <Menu.Header style={{ userSelect: "text" }}>
            {x.counterpartName}
          </Menu.Header>
          <Popup
            position="right center"
            content={
              ["confirmed", "missed", "incoming"].includes(x.type)
                ? "Incoming"
                : "Outgoing"
            }
            trigger={
              <Icon
                color={
                  ["missed", "confirmed"].includes(x.type) ? "red" : "green"
                }
                name={
                  ["missed", "confirmed", "incoming"].includes(x.type)
                    ? "reply"
                    : "mail forward"
                }
              />
            }
          />
          {new Date(toInteger(x.timestamp)).toLocaleString("en-GB", {
            dateStyle: "short",
            timeStyle: "short",
          })}
          ,{" "}
          <Popup
            position="right center"
            content="Duration as minutes:seconds"
            trigger={<span>{secondsToMMSS(x.callDuration / 1000)}</span>}
          />
          {!hasActiveCall() && x.counterpartName !== "Anonymous User" && (
            <Popup
              position="right center"
              content="Call back"
              trigger={
                <Icon
                  style={{ cursor: "pointer" }}
                  color="blue"
                  name="phone"
                  onClick={() => handleMakeCall(x.counterpartNumber, "audio")}
                />
              }
            />
          )}
        </SideScrollerSidebarItem>
      ))}
    </>
  );
}

export default CallLogs;
